import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Language } from '../../types'

interface I18nState {
  language: Language
  fallbackLanguage: Language
}

const initialState: I18nState = {
  language: 'en',
  fallbackLanguage: 'en'
}

const i18nSlice = createSlice({
  name: 'i18n',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload
      document.documentElement.lang = action.payload
    },
    setFallbackLanguage: (state, action: PayloadAction<Language>) => {
      state.fallbackLanguage = action.payload
    }
  }
})

export const { setLanguage, setFallbackLanguage } = i18nSlice.actions
export default i18nSlice.reducer 